// src/hooks/useCommentBarLayout.js
// Shared layout math for the mobile collapsible-comments-bar pattern used identically by
// ArticleDetail and EventsDetail (July 2026) — previously each computed the same
// header+footer+comment-bar arithmetic independently (verbatim duplicate blocks). Wraps
// useMediaQuery('detail') so the header/footer numbers come from one place, and adds the one
// piece of knowledge specific to this pattern: the 44px collapsed comment bar itself.

import useMediaQuery from './useMediaQuery';

const COMMENT_BAR_HEIGHT = 44;

export function useCommentBarLayout(commentsExpanded) {
  const { headerHeight, footerHeight, ...rest } = useMediaQuery('detail');

  return {
    ...rest,
    headerHeight,
    footerHeight,
    // Page wrapper padding — 0 when the bar is expanded (it overlays as a fixed sheet instead),
    // otherwise footer + the collapsed bar's own height.
    pageBottomPadding: commentsExpanded ? 0 : footerHeight + COMMENT_BAR_HEIGHT,
    // Scrollable article-body height — shrinks to the top half when the bar is expanded,
    // otherwise viewport minus header/footer/comment-bar.
    scrollHeight: commentsExpanded
      ? `calc(50vh - ${headerHeight}px)`
      : `calc(100vh - ${headerHeight + footerHeight + COMMENT_BAR_HEIGHT}px)`
  };
}

export default useCommentBarLayout;
